/**
 * ============================================================================
 * COMING SOON — placeholder body for a dashboard being onboarded.
 * ============================================================================
 *
 * Rendered instead of a page's content while a dashboard's structure declares
 * `comingSoon` (spec multi-dashboard; Quality until its metric definitions
 * publish). Follows the Cloudscape/AWS-console EMPTY STATE pattern: centered
 * muted icon + short bold title, no explanatory copy (the page header already
 * names the dashboard). A gentle breathe animation (index.scss) keeps it
 * feeling live without carnival motion — subtle pulse is the accepted
 * standard (skeleton/shimmer family); bouncing text is not.
 */

import React from 'react';
import Box from '@amzn/awsui-components-core/box';
import Icon from '@amzn/awsui-components-core/icon';

export const ComingSoon: React.FC<{ label: string }> = ({ label }) => (
  <div
    className="coming-soon"
    role="status"
    aria-label={`${label} coming soon`}
  >
    <Icon name="status-pending" size="large" variant="subtle" />
    <Box variant="strong" fontSize="heading-m">
      Coming soon
    </Box>
  </div>
);
